import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { title } from '@core/utils/filter'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useList() {
  // Use toast
  const toast = useToast()

  const refUserListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: 'nama_helpdesk', sortable: true, label: 'Nama Helpdesk' },
    { key: 'kategori_tiket', sortable: true, label: 'Kategori' },
    { key: 'sub_kategori_tiket', sortable: true, label: 'Jenis Pekerjaan' },
    { key: 'status_tiket', sortable: true, label: 'Status' },
    { key: 'tanggal', sortable: true, label: 'Tanggal' },
    { key: 'jumlah', sortable: true, label: 'Jumlah' },
    // { key: 'actions' },
  ]
  const perPage = ref(10)
  const totalUsers = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  const namaUserFilter = ref(null)
  const jenisKelaminFilter = ref(null)
  const provinsiFilter = ref(null)
  const kotaFilter = ref(null)
  const proyekFilter = ref(null)
  const umurAwalFilter = ref(null)
  const umurAkhirFilter = ref(null)

  const dataMeta = computed(() => {
    const localItemsCount = refUserListTable.value ? refUserListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalUsers.value,
    }
  })

  const refetchData = () => {
    refUserListTable.value.refresh()
  }

  watch([
    currentPage,
    perPage,
    searchQuery,
    namaUserFilter,
    jenisKelaminFilter,
    provinsiFilter,
    kotaFilter,
    proyekFilter,
    umurAwalFilter,
    umurAkhirFilter,
  ], () => {
    refetchData()
  })

  const fetchDatas = (ctx, callback) => {
    store
      .dispatch('report-list-helpdesk/fetchDatas', {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        proyek_id: proyekFilter.value,
        nama_user: namaUserFilter.value,
        jenis_kelamin: jenisKelaminFilter.value,
        provinsi: provinsiFilter.value,
        kota: kotaFilter.value,
        umur_awal: umurAwalFilter.value,
        umur_akhir: umurAkhirFilter.value,
      })
    // console.log(newSearch.value)
      .then(response => {
        // console.log(response)
        const { data, total } = response.data

        callback(data)
        totalUsers.value = total
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Tidak dapat mengambil data',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  const resolveUserRoleVariant = role => {
    if (role === 'subscriber') return 'primary'
    if (role === 'author') return 'warning'
    if (role === 'maintainer') return 'success'
    if (role === 'editor') return 'info'
    if (role === 'admin') return 'danger'
    return 'primary'
  }

  const resolveUserRoleIcon = role => {
    if (role === 'subscriber') return 'UserIcon'
    if (role === 'author') return 'SettingsIcon'
    if (role === 'maintainer') return 'DatabaseIcon'
    if (role === 'editor') return 'Edit2Icon'
    if (role === 'admin') return 'ServerIcon'
    return 'UserIcon'
  }

  const resolveUserStatusVariant = status => {
    if (status === 'pending') return 'warning'
    if (status === 'active') return 'success'
    if (status === 'inactive') return 'secondary'
    return 'primary'
  }

  return {
    fetchDatas,
    tableColumns,
    perPage,
    currentPage,
    totalUsers,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refUserListTable,

    resolveUserRoleVariant,
    resolveUserRoleIcon,
    resolveUserStatusVariant,
    refetchData,

    // Extra Filters
    namaUserFilter,
    jenisKelaminFilter,
    provinsiFilter,
    kotaFilter,
    proyekFilter,
    umurAwalFilter,
    umurAkhirFilter,
  }
}
